'use strict';

var jsxRuntime = require('react/jsx-runtime');

const SmallCollection = ({ testId, className })=>{
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: [
            jsxRuntime.jsx("path", {
                d: "M0.5 2.5H13.5",
                stroke: "currentColor",
                strokeWidth: "1.4",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M0.5 6.66205H6.78",
                stroke: "currentColor",
                strokeWidth: "1.4",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M0.5 10.8241H6.78",
                stroke: "currentColor",
                strokeWidth: "1.4",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M8.94994 7.13222C8.94994 6.57194 9.34994 6.03168 9.93994 6.03168H12.5099C12.5099 6.03168 12.5599 6.03168 12.5799 6.03168C13.1399 6.0717 13.4999 6.59195 13.4999 7.13222V10.854C13.4999 11.3643 12.9299 11.6745 12.4899 11.3943L11.2199 10.6039L9.94994 11.3943C9.50994 11.6644 8.93994 11.3543 8.93994 10.854V7.12221L8.94994 7.13222Z",
                fill: "currentColor"
            })
        ]
    });
};

module.exports = SmallCollection;
